<template>
  <div :class="$style['pt-integral-task-form']">
    <pt-sub-title title="任务信息"></pt-sub-title>
    <pt-form-item label="任务名称：" :labelWidth="labelWidth" :required="true">
      <el-input data-vv-as="任务名称" v-validate="'required'" v-model="formData.content" placeholder="请输入任务名称"></el-input>
    </pt-form-item>
    <pt-form-item label="说明文字：" :labelWidth="labelWidth" :required="true">
      <el-input data-vv-as="说明文字" v-validate="'required'" v-model="formData.description" placeholder="请输入说明文字"></el-input>
    </pt-form-item>
    <div :class="$style['multipInput']">
      <pt-form-item label="单次积分分值：" :labelWidth="labelWidth" :required="true">
        <el-input data-vv-as="单次积分分值" v-validate="'required'" v-model="formData.value" placeholder="请输入单次积分分值"></el-input>
      </pt-form-item>
      <span :class="$style.splitLine">/</span>
      <pt-form-item label="单位：" labelWidth="50px" :required="true">
        <el-input data-vv-as="单位" v-validate="'required'" v-model="formData.unit" placeholder="请输入单位"></el-input>
      </pt-form-item>
      <span>例：5分/日</span>
    </div>
    <pt-form-item label="上限：" :labelWidth="labelWidth" :required="true">
      <el-radio-group v-model="formData.limitType">
        <el-radio label="SINGLE_DAY_LIMIT">单日上限</el-radio>
        <el-radio label="TOTAL_LIMIT">累计上限</el-radio>
        <el-radio label="MONTH_LIMIT">月度上限</el-radio>
        <el-radio label="NO_LIMIT">无</el-radio>
      </el-radio-group>
    </pt-form-item>
    <pt-form-item label="上限次数：" :labelWidth="labelWidth" :required="formData.limitType !=='NO_LIMIT'">
      <el-input data-vv-as="上限次数" v-validate="formData.limitType !=='NO_LIMIT'&&'required'" v-model="formData.limitTimes" placeholder="请输入上限次数"></el-input>
      <span style="margin-left:10px;color:#b7b7b7;">例：传递科普 10分/篇 单日上限30分，此处选择3</span>
    </pt-form-item>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-integral-task-form'

export default {
  name: 'pt-integral-task-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      formData: this.value ? this.value : {
        rightText: '',
        type: 'GOODS',
        visibleInTools: false
      },
      labelWidth: '150px'
    }
  },
  watch: {
    value (val) {
      this.formData = val
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-integral-task-form{
  .multipInput{
    display: flex;
    align-items: center;
    >span{
      margin: 0 50px 5px;
      color:#b7b7b7;
      &.splitLine{
        font-size: 30px;
      }
    }
    :global{
      .el-input,.el-input__inner{
        max-width: 1.8rem;
        width: 1.8rem;
      }
    }
  }
  :global{
    .el-input{
      max-width: 2.8rem;
      width: 2.8rem;
    }
    .form-item .el-input,.el-input__inner{
      max-width: 2.8rem;
      width: 2.8rem;
    }
    .form-item .el-input--suffix .el-input__inner{
      min-width: 2.8rem;
    }
    el-textarea,.el-textarea__inner{
      width:500px;
    }
  }
}
</style>
